import axios from 'axios'
import { API_URL } from '../../../../modules/auth/core/_requests'

/**
 * Calls GET /api/shopify-shipping/orders/customer-shipping-data/:orderId
 * and returns the payload returned by the backend.
 */
export async function getCustomerShippingData(orderId: string): Promise<any> {
  try {
    const response = await axios.get(
      `${API_URL}/api/shopify-shipping/shared/customer-shipping/${orderId}`,
    )
    return response.data.data
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        throw new Error(
          error.response.data?.error ||
            'Failed to fetch customer-shipping data',
        )
      }
      throw new Error('Network error when fetching customer-shipping data')
    }
    throw error
  }
}